import { render, staticRenderFns } from "./wsTimer.vue?vue&type=template&id=1c71b342&scoped=true&"
import script from "./wsTimer.vue?vue&type=script&lang=js&"
export * from "./wsTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c71b342",
  null
  
)

export default component.exports